import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Conferences from './pages/Conferences';
import Community from './pages/Community';
import Organizer from './pages/Organizer';
import Mentor from './pages/Mentor';
import Publications from './pages/Publications';
import Projects from './pages/Projects';
import ProfessionalServices from './pages/ProfessionalServices';
import Trainings from './pages/Trainings';
import Assessment from './pages/Assessment';
import CloudConsulting from './pages/CloudConsulting';
import IaCConsulting from './pages/IaCConsulting';
import CICDConsulting from './pages/CICDConsulting';
import './styles/main.css';

const App: React.FC = () => {
  return (
    <Router>
      <Navigation />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/professional-services" element={<ProfessionalServices />} />
        <Route path="/trainings" element={<Trainings />} />
        <Route path="/assessment" element={<Assessment />} />
        <Route path="/cloud-consulting" element={<CloudConsulting />} />
        <Route path="/iac-consulting" element={<IaCConsulting />} />
        <Route path="/cicd-consulting" element={<CICDConsulting />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/conferences" element={<Conferences />} />
        <Route path="/community" element={<Community />} />
        <Route path="/mentor" element={<Mentor />} />
        <Route path="/organizer" element={<Organizer />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/projects" element={<Projects />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;